import React, { Component } from 'react';
import { getText } from '../config';

class DestinationsFlights extends Component {
    constructor(props) {
        super(props);

        this.state = {
            fixedHeight: null
        }
    }

    setFixedHeight() {
        this.setState({
            fixedHeight: document.documentElement.clientHeight
        })
    }

    removeFixedHeight() {
        this.setState({
            fixedHeight: null
        })
    }

    render() {
        return (
            <div className="destinations" style={this.state.fixedHeight ? {height: this.state.fixedHeight} : {}}>
                <div className={"destinations-header" + (this.props.withMargin ? ' with-margin' : '')}>
                    <span>{getText('selectDestinations')}</span>
                    <input
                        className="input"
                        type="text"
                        onFocus={this.setFixedHeight.bind(this)}
                        onBlur={this.removeFixedHeight.bind(this)}
                        onChange={this.props.onDestinationInput}
                        placeholder={this.props.destination || this.props.placeholderText} />
                </div>
                {!this.props.destinationInput && <div className="destinations-favorites">{getText('bestDestinations')}</div>}
                {this.props.destinationInput && this.props.destinations.length === 0 && this.props.searchType === 'hotel' && <div className="destinations-favorites">{getText('noDestination')}</div>}
                <ul className="destinations-list">
                    {this.props.destinations.map((destination) => {
                        if(this.props.destinationInput) {
                            const startMatch = destination.label.toLowerCase().indexOf(this.props.destinationInput.toLowerCase());
                            const endMatch = this.props.destinationInput.length + startMatch;
                            return (
                                <li
                                    onClick={this.props.selectDestination.bind(null, destination)}
                                    key={destination.value}
                                    className={this.props.destination === destination.label ? "selected" : ""}>
                                    <span>{destination.label.substring(0, startMatch)}</span>
                                    <span
                                        className={this.props.destination === destination.label ? "" : "destinations-list-match"}>{destination.label.substring(startMatch, endMatch)}</span>
                                    <span>{destination.label.substring(endMatch)}</span>
                                </li>
                            )
                        } else {
                            return (
                                <li
                                    onClick={this.props.selectDestination.bind(null, destination)}
                                    key={destination.value}
                                    className={this.props.destination === destination.label ? "selected" : ""}>
                                    <span>{destination.label}</span>
                                </li>
                            )
                        }
                    })}
                </ul>
            </div>
        );
    }
}

DestinationsFlights.propTypes = {
    //myProp: PropTypes.type.isRequired
};

export default DestinationsFlights;


// WEBPACK FOOTER //
// ./src/components/DestinationsFlights.js